<template>
	<section class="iv2-page-header">
		<div class="overflow-hidden">
			<div class="iv2-page-header__title position-relative">
				<h1
					class="iv2-page-header__main-title theme-c__page-header-title h4 m-0"
				>{{ contact.page_title }}</h1>
				<p
					class="iv2-page-header__sub-title theme-c__page-header-sub-title m-0"
				>{{ contact.page_subtitle }}</p>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: ["contact"]
};
</script>

<style lang="scss">
.iv2-page-header__title {
	.iv2-page-header__main-title {
		font-size: 1.5rem;
		font-weight: bold;
	}

	.iv2-page-header__sub-title {
		font-size: 1rem;
		font-weight: 600;
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-page-header__title {
		padding: 50px;
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-page-header__title {
		padding: 30px;
	}
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-page-header__title {
		padding: 20px;
	}
}
</style>